import Vue from "vue";
function addStyles(win, styles) {
  // styles.forEach(style => {
  //   let link = win.document.createElement("link");
  //   link.setAttribute("rel", "stylesheet");
  //   link.setAttribute("type", "text/css");
  //   link.setAttribute("href", style);
  //   win.document.getElementsByTagName("head")[0].appendChild(link);
  // });
  win.document.getElementsByTagName("head")[0].appendChild(`
  <style>
  .div_cerceve {
    background-color: white;
    border-style: solid;
    border-width: 1px;
  }
  
  .dikeyBaslik {
    float: left;
    font-size: 16px;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }
  
  .formelemanlari {
    margin: 0px;
    width: 590px;
    height: 48px;
    position: absolute;
    left: 1px;
    top: 0px;
    font-size: 11px;
  }
  
  .formelemanlari2 {
    margin: 0px;
    width: 699px;
    height: 249px;
    font-size: 24px;
    background-color: #ddf1ff;
  }
  
  .guideleman {
    display: none;
  }
  </style>`);
}

const VueShaeskToPaper = {
  install(Vue, options = {}) {
    Vue.prototype.$printToHtml = (el, localOptions, cb = () => true) => {
      let defaultName = "_blank",
        defaultSpecs = ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        defaultReplace = true,
        defaultStyles = [];
      let {
        name = defaultName,
        specs = defaultSpecs,
        replace = defaultReplace,
        styles = defaultStyles
      } = options;

      if (localOptions) {
        if (localOptions.name) name = localOptions.name;
        if (localOptions.specs) specs = localOptions.specs;
        if (localOptions.replace) replace = localOptions.replace;
        if (localOptions.styles) styles = localOptions.styles;
      }

      specs = specs.length ? specs.join(",") : "";

      const element = window.document.getElementsByClassName(el);
      if (!element) {
        alert(`Element to print #${el} not found!`);
        return;
      }

      const url = "";
      const win = window.open(url, name, specs, replace);
      var printBody = element[0].innerHTML;
      win.document.write(`
          <html>
            <head>
              <title>${window.document.title}</title>
              <style>
                .div_cerceve {
                  background-color: white;
                  border-style: solid;
                  border-width: 1px;
                  }
  
  .dikeyBaslik {
    float: left;
    font-size: 16px;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }
  
  .formelemanlari {
    margin: 0px;
    width: 590px;
    height: 48px;
    position: absolute;
    left: 1px;
    top: 0px;
    font-size: 11px;
  }
  
  .formelemanlari2 {
    margin: 0px;
    width: 699px;
    height: 249px;
    font-size: 24px;
    background-color: #ddf1ff;
  }
  
  .guideleman {
    display: none;
  }

              </style>
            </head>
            <body>
              ${printBody}
            </body>
          </html>
        `);

      addStyles(win, styles);

      setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        win.close();
        cb();
      }, 1000);

      return true;
    };
  }
};

export default VueShaeskToPaper;

Vue.use(VueShaeskToPaper);
